module.exports = __webpack_public_path__ + "static/media/1.3c8c7b12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/magazine/1.jpg
// module id = 54
// module chunks = 0